import { render, staticRenderFns } from "./Teen12.vue?vue&type=template&id=e65e63c6&scoped=true&"
import script from "./Teen12.vue?vue&type=script&lang=js&"
export * from "./Teen12.vue?vue&type=script&lang=js&"
import style0 from "./Teen12.vue?vue&type=style&index=0&id=e65e63c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65e63c6",
  null
  
)

export default component.exports